import { createSelector } from 'reselect';
import { connect } from 'react-redux';
import FrameworkUtils from 'utils/framework';
import { userSelector } from 'selectors/user/userSelector';
import { myListsSelector } from 'selectors/page/myLists/myListsSelector';
import { lovesSelector } from 'selectors/loves/lovesSelector';
import myListsUtils from 'utils/MyLists';
import LimitedLoveListItemsSelector from 'selectors/loves/limitedLoveListItems/limitedLoveListItemsSelector';
import LoveActions from 'actions/LoveActions';
const { wrapHOC } = FrameworkUtils;
const { limitedLoveListItemsSelector } = LimitedLoveListItemsSelector;

const fields = createSelector(
    userSelector,
    myListsSelector,
    lovesSelector,
    limitedLoveListItemsSelector,
    (user, myLists, loves, limitedLoveListItems) => {
        const isSharableListEnabled = myListsUtils.isSharableListEnabled();

        return {
            user,
            myLists,
            limitedLoveListItems,
            isSharableListEnabled,
            ...(isSharableListEnabled && { loves })
        };
    }
);

const functions = dispatch => ({
    getAllLists: ({ profileId }) => {
        const action = LoveActions.getAllLists(profileId);
        dispatch(action);
    },
    fetchAllLovedItems: ({ force } = {}) => {
        const action = LoveActions.getFlatLoveListSkusWithDetails({ force });
        dispatch(action);
    },
    getLimitedLoveListItems: ({ callback, refreshCache, options }) => {
        const action = LoveActions.getLimitedLoveListItems({ callback, force: refreshCache, options });
        dispatch(action);
    }
});

const withInlineLovesProps = wrapHOC(connect(fields, functions));

export {
    fields, functions, withInlineLovesProps
};
